<template>
  <div class="jiugongge">
 <div v-for="(v,i) in hdArr" :key="i">
 <vidobox @delobj="delVedio" :isShowAdd="isShowAdd" :id="'vidos'+i" :url="qing==1?v.liveUrl:v.liveUrlHd" :list="v" :height="150" :kbottom="'0px'" :kheight="'30px'" :token="token" :fontsize="'20px'"/>
</div>

<div v-show="hdArr.length<v" v-for="(v,i) in 9" :key="i">
  <img src="../../assets/image/暂无视频@2x.png" alt="">
    <p>点击
      <span>视频监控列表</span>
       加载视频流</p>
</div>
</div>
 </template>
 
 <script>
  var flage=1
 export default {
   props: {
       hdArr:{
           default:[]
       },
       qing:{
           default:1
       },
       token:{
           default:''
       },
        isShowAdd:{
          default:true,
        }
     
   },
   data() {
     return {
       width:0,
height:0,
     };
   },
   mounted(){
     this.getBox()
 },
 
 beforeDestroy(){
 },
   methods: {
     getBox(){
        let box=document.getElementsByClassName('videobox')
        console.log(box,76);
            this.width = box[0].clientWidth;
        this.height = box[0].clientHeight;
      },
      delVedio(obj){
        this.$emit('delobj', obj);
      }
 }
 
 }
 
 
 </script>
  
  <style lang="scss" scoped>
 .jiugongge{
          width: 100%;
          height: 100%;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-around;
          align-items: center;
          >div{
             width: 32%;
          height: 30%;
          background: #16385E;
              border-radius: .5rem;
          display: flex;
          flex-direction: column;
            justify-content: center;
            align-items: center;
            img{
              width: 20%;
              margin-bottom: 3%;
            }
            p{
              font-size: .875rem;
              color: #5D7C9E;
              span{
                color: #ffffffa0;
              }
            }
          }
         
        }
        </style>